import { type PrimaryPageAction, EmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import type { GetEphemeralEnvironmentsOnboardingDataBffResponse, ProjectResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { EphemeralEnvironmentsConfigWizard } from "~/areas/projects/components/EphemeralEnvironments/ConfigurationWizard/EphemeralEnvironmentsConfigWizard";
import { useDialogTrigger } from "~/components/Dialog/DialogTrigger";
import { EphemeralEnvironmentsEmptyStateIllustration } from "./EphemeralEnvironmentsEmptyStateIllustration";
import { useEphemeralEnvironmentsConfigWizard } from "./useEphemeralEnvironmentsConfigWizard";
type EphemeralEnvironmentsOnboardingProps = {
    project: ProjectResource;
    onboardingData: GetEphemeralEnvironmentsOnboardingDataBffResponse;
    reloadConfiguration: () => void;
};
export function EphemeralEnvironmentsOnboarding({ project, onboardingData, reloadConfiguration }: EphemeralEnvironmentsOnboardingProps) {
    const useConfigWizard = useEphemeralEnvironmentsConfigWizard();
    const configWizardDialogControls = useDialogTrigger();
    const canCreateChannels = onboardingData.Permissions.CreateChannels;
    function openConfigWizard() {
        configWizardDialogControls.openDialog();
    }
    function closeConfigWizard() {
        configWizardDialogControls.closeDialog();
        reloadConfiguration();
    }
    let primaryAction: PrimaryPageAction | undefined = undefined;
    if (!useConfigWizard) {
        primaryAction = {
            label: "Configure Channel",
            path: links.channelsPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }),
            type: "navigate",
        };
    }
    else {
        primaryAction = {
            label: "Configure Ephemeral Environments",
            type: "button",
            onClick: openConfigWizard,
            disabled: !canCreateChannels,
            extraContext: !canCreateChannels ? "You need permission to create channels to configure ephemeral environments" : undefined,
        };
    }
    return (<>
            <EmptyStateOnboarding description={<div>
                        <div>Automatically spin up test environments while keeping your infrastructure costs down.</div>
                        {!useConfigWizard && <div>Configure a new channel to enable Ephemeral Environments.</div>}
                    </div>} primaryAction={primaryAction} title="Gain confidence in your changes with test environments on demand" image={<EphemeralEnvironmentsEmptyStateIllustration />}/>
            {useConfigWizard && <EphemeralEnvironmentsConfigWizard isOpen={configWizardDialogControls.isOpen} closeDialog={closeConfigWizard} onboardingData={onboardingData} project={project}/>}
        </>);
}
